// extracted by mini-css-extract-plugin
export var backdrop = "index-module--backdrop--A8piP";
export var container = "index-module--container--e4TYO";
export var products = "index-module--products--Qs9kq";
export var subtitle = "index-module--subtitle--Ap0Ej";
export var title = "index-module--title--3iyV4";